import type { Action, ActionStatusType } from "../actions.types";
import { ACTION_STATUS } from "../actions.constants";

/**
 * Determines if an action's status should be updated to the new status.
 *
 * Rules:
 * - Never downgrade from "Completed" to "In Progress" or "Not Started"
 * - Never re-set "In Progress" if already "In Progress"
 * - Always allow setting to "Completed"
 * - Always allow setting to "In Progress" from "Not Started"
 *
 * @param action - The action to check
 * @param newStatus - The desired new status
 * @returns true if the status should be updated, false otherwise
 */
export function shouldUpdateStatus(
  action: Action,
  newStatus: ActionStatusType
): boolean {
  const currentStatus = action.current_status?.name;

  // If no current status, allow any update
  if (!currentStatus) {
    return true;
  }

  // If already completed, never downgrade
  if (currentStatus === ACTION_STATUS.COMPLETED) {
    return newStatus === ACTION_STATUS.COMPLETED;
  }

  // If already in progress, don't re-set to in progress
  if (currentStatus === ACTION_STATUS.IN_PROGRESS) {
    return newStatus !== ACTION_STATUS.IN_PROGRESS;
  }

  // From "Not Started", allow any transition
  return true;
}

